import { toast } from "react-hot-toast";
import { errorToastOptions } from "utils/toasterStyles";

export const toastServerError = (error: any, defaultMessage?: string) => {
  toast(
    error?.response?.data?.message || defaultMessage || "Something went wrong",
    errorToastOptions
  );
};
